
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1021),
  bluePlayerCampCount: Number.withConstraint(x => x >= 0),
  bluePlayerCount: Number.withConstraint(x => x >= 0),
  blueSpectatorCount: Number.withConstraint(x => x >= 0),
  blueVillageCount: Number.withConstraint(x => x >= 0),
  destroyedBlueTowers: Number.withConstraint(x => x >= 0),
  destroyedRedTowers: Number.withConstraint(x => x >= 0),
  destroyerOfBlueCap: Number.withConstraint(x => x >= 0),
  destroyerOfRedCap: Number.withConstraint(x => x >= 0),
  eventEndTimestamp: Number.withConstraint(x => x >= -1),
  lmsBlueStartDate: Number.withConstraint(x => x >= -1),
  lmsRedStartDate: Number.withConstraint(x => x >= -1),
  redPlayerCampCount: Number.withConstraint(x => x >= 0),
  redPlayerCount: Number.withConstraint(x => x >= 0),
  redSpectatorCount: Number.withConstraint(x => x >= 0),
  redVillageCount: Number.withConstraint(x => x >= 0),
  winningFaction: Number.withConstraint(x => x >= -1 && x <= 1),
}).And(Partial({
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1021),
  bluePlayerCampCount: Number.withConstraint(x => x >= 0),
  bluePlayerCount: Number.withConstraint(x => x >= 0),
  blueSpectatorCount: Number.withConstraint(x => x >= 0),
  blueVillageCount: Number.withConstraint(x => x >= 0),
  destroyedBlueTowers: Number.withConstraint(x => x >= 0),
  destroyedRedTowers: Number.withConstraint(x => x >= 0),
  destroyerOfBlueCap: Number.withConstraint(x => x >= 0),
  destroyerOfRedCap: Number.withConstraint(x => x >= 0),
  eventEndTimestamp: Number.withConstraint(x => x >= -1),
  lmsBlueStartDate: Number.withConstraint(x => x >= -1),
  lmsRedStartDate: Number.withConstraint(x => x >= -1),
  redPlayerCampCount: Number.withConstraint(x => x >= 0),
  redPlayerCount: Number.withConstraint(x => x >= 0),
  redSpectatorCount: Number.withConstraint(x => x >= 0),
  redVillageCount: Number.withConstraint(x => x >= 0),
  winningFaction: Number.withConstraint(x => x >= -1 && x <= 1),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1021;
  